import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';
import { customerUiResources } from './customerUiResources';
import serviceUiResources from './serviceUiResources';

const mergedResources = Object.fromEntries(
  Object.entries(resources).map(([language, namespaces]) => [
    language,
    {
      ...namespaces,
      translation: {
        ...namespaces.translation,
        ...customerUiResources[language],
        ...serviceUiResources[language],
      },
    },
  ])
);

i18n
  .use(initReactI18next)
  .init({
    resources: mergedResources,
    lng: 'fa',
    fallbackLng: 'fa',
    supportedLngs: Object.keys(mergedResources),
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
